import { render, staticRenderFns } from "./BaseSlider.vue?vue&type=template&id=fe9efe94&scoped=true&"
import script from "./BaseSlider.vue?vue&type=script&lang=js&"
export * from "./BaseSlider.vue?vue&type=script&lang=js&"
import style0 from "./BaseSlider.vue?vue&type=style&index=0&id=fe9efe94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9efe94",
  null
  
)

export default component.exports